"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var querystring_1 = __importDefault(require("querystring"));
var lodash_1 = require("lodash");
var makeQueryString = function (oldParams, mergeParams) {
    var newParams = lodash_1.extend({}, oldParams, mergeParams);
    return querystring_1.default.stringify(newParams);
};
exports.default = makeQueryString;
